import React from 'react';

import { CircularProgress } from '@lyearn/ui';

interface Props {
  progress: number;
}

function SmallJobProgress(props: Props) {
  const { progress = 0 } = props;

  return <CircularProgress color="success" size="x-small" value={progress} />;
}

export default SmallJobProgress;
